import React from 'react';
import { CheckCircle2, Clock, Info, ShieldAlert } from 'lucide-react';
import { ASSIGNMENT_END_REASON, ASSIGNMENT_END_REASON_UI } from '../../constants';
import { cn } from '../ui/utils';

const TONE_STYLES = {
  success: {
    container: 'border-emerald-200/80 bg-gradient-to-br from-emerald-50 via-white to-[#C0E281]/15',
    iconWrap: 'border-emerald-200 bg-emerald-100 text-emerald-700',
    title: 'text-emerald-900',
    description: 'text-emerald-800/80',
    badge: 'bg-emerald-100 text-emerald-800'
  },
  warning: {
    container: 'border-amber-200/80 bg-gradient-to-br from-amber-50 via-white to-orange-50',
    iconWrap: 'border-amber-200 bg-amber-100 text-amber-700',
    title: 'text-amber-900',
    description: 'text-amber-800/80',
    badge: 'bg-amber-100 text-amber-800'
  },
  alert: {
    container: 'border-rose-200/80 bg-gradient-to-br from-rose-50 via-white to-orange-50',
    iconWrap: 'border-rose-200 bg-rose-100 text-rose-700',
    title: 'text-rose-900',
    description: 'text-rose-800/80',
    badge: 'bg-rose-100 text-rose-800'
  },
  info: {
    container: 'border-sky-200/80 bg-gradient-to-br from-sky-50 via-white to-primary/5',
    iconWrap: 'border-sky-200 bg-sky-100 text-sky-700',
    title: 'text-sky-900',
    description: 'text-sky-800/80',
    badge: 'bg-sky-100 text-sky-800'
  }
};

const REASON_ICONS = {
  [ASSIGNMENT_END_REASON.TIME_OVER]: Clock,
  [ASSIGNMENT_END_REASON.STUDENT_ENDED]: CheckCircle2,
  [ASSIGNMENT_END_REASON.STRICT_MODE_TIME_VIOLATION]: ShieldAlert,
  [ASSIGNMENT_END_REASON.STRICT_MODE_TAB_VIOLATION]: ShieldAlert,
  [ASSIGNMENT_END_REASON.ALREADY_COMPLETED]: Info
};

const EndReasonBanner = ({ reasonCode }) => {
  const reasonKey = ASSIGNMENT_END_REASON_UI[reasonCode]
    ? reasonCode
    : ASSIGNMENT_END_REASON.STUDENT_ENDED;
  const meta = ASSIGNMENT_END_REASON_UI[reasonKey];
  const styles = TONE_STYLES[meta.tone] || TONE_STYLES.info;
  const Icon = REASON_ICONS[reasonKey] || Info;

  return (
    <div
      role="status"
      className={cn(
        'mb-6 w-full max-w-lg overflow-hidden rounded-2xl border p-4 shadow-sm sm:p-5',
        styles.container
      )}
    >
      <div className="flex items-start gap-3.5 text-left">
        <div
          className={cn(
            'flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border',
            styles.iconWrap
          )}
        >
          <Icon className="h-5 w-5" aria-hidden />
        </div>

        <div className="min-w-0 flex-1">
          <div className="mb-1.5 flex flex-wrap items-center gap-2">
            <span
              className={cn(
                'inline-flex rounded-full px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-wide',
                styles.badge
              )}
            >
              Submission reason
            </span>
          </div>
          <h2 className={cn('text-base font-semibold leading-snug', styles.title)}>{meta.title}</h2>
          <p className={cn('mt-1 text-sm leading-relaxed', styles.description)}>
            {meta.description}
          </p>
        </div>
      </div>
    </div>
  );
};

export default EndReasonBanner;
